import { Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { AdminAuthProvider, useAdminAuth } from "./AdminAuthContext";
import { AdminLayout } from "./AdminLayout";

import AdminLogin from "./pages/AdminLogin";
import AdminForgotPassword from "./pages/AdminForgotPassword";
import AdminResetPassword from "./pages/AdminResetPassword";
import AdminDashboard from "./pages/AdminDashboard";
import AdminVisitors from "./pages/AdminVisitors";
import AdminSubmissions from "./pages/AdminSubmissions";
import AdminContent from "./pages/AdminContent";
import AdminSettings from "./pages/AdminSettings";
import AdminAdmins from "./pages/AdminAdmins";
import AdminChangePassword from "./pages/AdminChangePassword";

function Protected({ children, superOnly = false }) {
  const { user, loading } = useAdminAuth();
  if (loading || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F4F6F8] text-[#4B5563]">
        <Loader2 className="animate-spin" size={22} />
      </div>
    );
  if (!user) return <Navigate to="/admin/login" replace />;
  if (superOnly && user.role !== "super_admin") return <Navigate to="/admin" replace />;
  return <AdminLayout>{children}</AdminLayout>;
}

export default function AdminApp() {
  return (
    <AdminAuthProvider>
      <Routes>
        <Route path="login" element={<AdminLogin />} />
        <Route path="forgot-password" element={<AdminForgotPassword />} />
        <Route path="reset-password" element={<AdminResetPassword />} />
        <Route index element={<Protected><AdminDashboard /></Protected>} />
        <Route path="visitors" element={<Protected><AdminVisitors /></Protected>} />
        <Route path="submissions" element={<Protected><AdminSubmissions /></Protected>} />
        <Route path="content" element={<Protected><AdminContent /></Protected>} />
        <Route path="settings" element={<Protected><AdminSettings /></Protected>} />
        <Route path="admins" element={<Protected superOnly><AdminAdmins /></Protected>} />
        <Route path="change-password" element={<Protected><AdminChangePassword /></Protected>} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </AdminAuthProvider>
  );
}
